import {Component, inject} from '@angular/core'
import {MatButton} from '@angular/material/button'
import {MatCard} from '@angular/material/card'
import {MatDialog} from '@angular/material/dialog'
import {MatSnackBar} from '@angular/material/snack-bar'
import {IDocument} from '@sparbanken-syd/user-documents-backend'
import {filter, switchMap} from 'rxjs'
import {SelectedComponent} from '../../components/selected/selected.component'
import {DocumentService} from '../../services/document.service'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {ConfirmComponent, IConfirmComponentData} from '@sparbanken-syd/sparbanken-syd-theme'

@Component({
  selector: 'spb-document',
  templateUrl: './document.component.html',
  styleUrl: './document.component.scss',
  imports: [
    MatButton,
    MatCard,
    SelectedComponent
  ]
})
export class DocumentComponent {

  public readonly configService = inject(ConfigService)
  public readonly documentService = inject(DocumentService)
  private readonly dialog = inject(MatDialog)
  private readonly snackBar = inject(MatSnackBar)

  public deleteFile(id: string, fileName: string): void {
    this.dialog.open<ConfirmComponent, IConfirmComponentData, boolean>(ConfirmComponent, {
      data: {title: 'Radera fil', text: `Är du säker på att du vill radera ${fileName}`}
    }).afterClosed()
      .pipe(
        filter(Boolean),
        switchMap(() => this.documentService.deleteDocument(id))
      )
      .subscribe(() => {
        this.documentService.savedDocuments.update(sds => sds.filter((d: IDocument) => d.id !== id))
        this.snackBar.open('Filen har raderats', '', {duration: 2000})
      })
  }
}
